import React, { useState } from "react";
import { Viewer, Worker } from '@react-pdf-viewer/core';

import '@react-pdf-viewer/core/lib/styles/index.css';
import { useDropzone } from 'react-dropzone';
import { Button } from "react-bootstrap";
import { baseUrl } from "../utils/apiActions/dashboardApi";
import { toastError } from "../utils/toastrResponse";

const PdfUpload = ({  paymentId,onHide }) => {
    const [file, setFile] = useState(null);
    const [fileUrl, setFileUrl] = useState(null);
    const user = JSON.parse(localStorage.getItem("user"))
  const onDrop = (acceptedFiles) => {
      setFileUrl(URL.createObjectURL(acceptedFiles[0]));
    setFile(acceptedFiles[0]);
  };

  const { getRootProps, getInputProps } = useDropzone({
    accept: "application/pdf",
    onDrop,
  });
    const UploadFile = (e) => {
        e.preventDefault();
        const formData = new FormData()
        formData.append("file", file)
      const url = `${baseUrl}/payments/${paymentId}/documents`;
      fetch(url, {
        method: "POST",
        headers: new Headers({
          Authorization: "Bearer " + user.access_token,
        }),
        body: formData,
      })
        .then((res) => {
          if (res.ok) {
            onHide();
          } else {
            toastError("Could not create upload payment proof");
          }
          return res.json();
        })
        .then((res) => {
        })
        .catch((err) => {
          console.log(err);
        });
    };

  return (
    <div>
      <div
        {...getRootProps({ className: "dropzone" })}
        style={{
          border: "2px dashed #cccccc",
          padding: "20px",
          textAlign: "center",
        }}
      >
        <input {...getInputProps()} />
        <p>Drag 'n' drop a PDF file here, or click to select one</p>
      </div>

      {file && (
        <div>
          <div className='d-flex justify-content-center m-3'>
            <Button onClick={UploadFile}> UPLOAD</Button>
          </div>
          <Worker workerUrl='https://unpkg.com/pdfjs-dist@3.6.172/build/pdf.worker.min.js'>
            <Viewer fileUrl={fileUrl} />
          </Worker>
        </div>
      )}
    </div>
  );
};

export default PdfUpload;
